import LogoOnlyIcon from "@/assets/images/logo-only-logo.svg";
import LogoIcon from "@/assets/images/logo-with-vidmuse.svg";
import Link from "next/link";
import React from "react";
import styles from "../index.module.css";

export const Logo: React.FC = () => (
  <Link
    href="/"
    className={`flex items-center ${styles.logo}`}
    aria-label="VidMuse home"
  >
    <LogoOnlyIcon
      className="text-text-primary w-8 sm:hidden"
      aria-label="VidMuse"
      role="img"
    />
    <LogoIcon
      className="text-text-primary w-[128px] hidden sm:block"
      alt="VidMuse"
      role="img"
    />
  </Link>
);
